export const TIPS = {
    NAME: {
        ROUTES: {
            HOME_VIEW: 'home_view',
            LISTAS_VIEW: 'listas_view',
            CAJAS_VIEW: 'cajas_view',
            ACCESO_CAJAS_VIEW: 'acceso_cajas_view',
            CIERRE_TESORERIA_VIEW: 'cierre_tesoreria_view',
            CIERRE_CAJAS_HISTORIAL_VIEW: 'cierre_cajas_historial_view',
            RECAUDACION_IMPORTACION_VIEW: 'recaudacion_importacion_view',
            RECAUDACION_CONTROL_VIEW: 'recaudacion_control_view',
            RECAUDACION_CONCILIACION_VIEW: 'recaudacion_conciliacino_view',
            RECAUDACION_HISTORIAL_VIEW: 'recaudacion_historial_view',
            RENDICION_INGRESOS_PUBLICOS_VIEW: 'rendicion_ingresos_publicos_view',
            RENDICION_REGISTRO_CONTABLE_VIEW: 'rendicion_registro_contable_view',
            RENDICION_REGISTRO_CONTABLE_HISTORIAL_VIEW: 'rendicion_registro_contable_historial_view',
            RENDICION_INGRESOS_PUBLICOS_HISTORIAL_VIEW: 'rendicion_ingresos_publicos_historial_view',
            DEVOLUCION_IMPORTACION_VIEW: 'devolucion_importacion_view',
            DEVOLUCION_CONCILIACION_VIEW: 'devolucion_conciliacion_view',
            DEVOLUCION_HISTORIAL_VIEW: 'devolucion_historial_view',
            DEVOLUCION_RENDICION_INGRESOS_PUBLICOS_VIEW: 'devolucion_rendicion_ingresos_publicos_view',
            DEVOLUCION_RENDICION_REGISTRO_CONTABLE_VIEW: 'devolucion_rendicion_registro_contable_view',
            DEVOLUCION_RENDICION_INGRESOS_PUBLICOS_HISTORIAL_VIEW: 'devolucion_rendicion_ingresos_publicos_historial_view',
            DEVOLUCION_RENDICION_REGISTRO_CONTABLE_HISTORIAL_VIEW: 'devolucion_rendicion_registro_contable_historial_view',
            NOT_FOUND: 'not_found',
            CONTROL_PROCESOS_VIEW: 'control_procesos_view',
        },
        MODALS: {
            EXPEDIENTE_MODAL_NUEVO: 'expediente_modal_nuevo',
            EXPEDIENTE_MODAL_VIEW: 'expediente_modal_view',
            LISTAS_MODAL: 'listas_modal',
            ENTIDAD_MODAL: 'entidad_modal',
            SELECCION_TASA_MODAL: 'seleccion_tasa_modal',
            SELECCION_PERSONA_MODAL: 'seleccion_persona_modal',
            SELECCION_SUB_TASA_MODAL: 'seleccion_sub_tasa_modal',
            PROCESO_MODAL: 'proceso_modal',
            INFORMACION_ADICIONAL_PROCESO_MODAL: 'informacion_adicional_proceso_modal'
        }
    },
};
